export default "__VITE_ASSET__BIZhGL0Z__";